<div class="auth-tire-dot-number flex-column">
  <ng-container *ngFor="let service of dotNumberServices">
    <div class="border-lightest bg-white" *ngFor="let serviceItem of service?.dotNumberItems">
      <div class="auth-tire-info-header flex-column">
        <div class="flex-row gap-10px">
          <span class="font-16 font-700">{{serviceItem?.title}}</span>
          <span class="font-14 font-400 font-secondary" *ngIf="service?.serviceStatus === 'deferred'">
            Qty: {{serviceItem.count}}
          </span>
        </div>
        <div class="flex-column">
          <div class="flex-start-end gap-6px">
            <span class="font-14 font-600">Associated service:</span>
            <span class="font-14 font-400">{{service?.title}}</span>
            <span class="pill-tag" [ngClass]="service?.serviceStatus"
              *ngIf="['approved', 'deferred', 'decline'].includes(service?.serviceStatus)">
              {{service?.serviceStatus}}
            </span>
          </div>
          <span class="font-14 font-400 font-secondary" *ngIf="service?.serviceStatus === 'deferred'">
            The associated service is deffered. Please approve service to enter DOT numbers
          </span>
        </div>
      </div>
      <div class="body-tire-dot-number" *ngIf="!['deferred', 'decline'].includes(service?.serviceStatus)">
        <tire-add-dot-number [data]="serviceItem"
          (onInputChange)="handleChange($event?.value, $event.item, service?._id, serviceItem)"
          (onSwitchBtnChange)="onCardTypeSelect($event?.data, $event?.item, service?._id, serviceItem)">
        </tire-add-dot-number>
      </div>
    </div>
  </ng-container>
</div>
